
import { defineComponent, reactive, onMounted, computed, ref, watch, nextTick } from "vue";
import { ethitransService } from "@/services/EthitransService";
import { common } from "@/common/services/Common";
import { useRoute, useRouter, onBeforeRouteLeave } from "vue-router";
// import Multiselect from 'vue-multiselect';
import moment from "moment";
import SuccessfulModalCustom from "@/components/modal/SuccessfulModalCustom.vue";
import CreateLineItemInJobEstimation from "../todo/CreateLineItemInJobEstimation.vue";
import Editor from "@/components/mention/Editor.vue";
import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
import { config } from "@/Config";
import cloneDeep from 'lodash/cloneDeep';
import SignaturePadModal from "@/components/modal/SignaturePadModal.vue";
import SignatureUploadModal from "@/components/modal/SignatureUploadModal.vue";
import ErrorList from "@/components/commonDesign/ErrorList.vue";
// import GoogleAddressCustomer from "../commonDesign/GoogleAddressCustomer.vue";
import ToDoChatChannelModel from "../todo/ToDoChatChannelModel.vue";
import AppEmailAndPhoneNumberValidate from "../commonDesign/AppEmailAndPhoneNumberValidate.vue";
import AppPhoneNumberInput from "@/components/commonDesign/AppPhoneNumberInput.vue";
import { validationService } from "@/common/ValidationService";
import { useDebouncedRef } from "@/common/useDebouncedRef";
import VoiceToText from "@/components/VoiceToText.vue";
import CurrencyInput from "./components/CurrencyInput.vue";
import CustomModal from '@/components/ui/customModal/index.vue'
import CustomLoader from '@/components/ui/loader/index.vue'

export default defineComponent({
    name: "ProjectWorkflowUpdateJobEstimation",
    props: {
        editId: {
            type: String,
            required: true,
        },
        projectName: String,
    },
    components: {
        SuccessfulModalCustom,
        CreateLineItemInJobEstimation,
        // Multiselect,
        Editor,
        SignaturePadModal,
        SignatureUploadModal,
        ErrorList,
        // GoogleAddressCustomer,
        ToDoChatChannelModel,
        AppEmailAndPhoneNumberValidate,
        AppPhoneNumberInput,
        VoiceToText,
        CurrencyInput,
        CustomModal,
        CustomLoader
    },
    
    setup(props, { emit }) {
        const router = useRouter();
        const {
            params: { estimationId },
        } = useRoute();
        const route = useRoute();
        const table = ref(); //reference to your table element
        const tabulator = ref(); //variable to hold your table
        const filterValue = ref();
        const {
            params: { projectId },
        } = useRoute();
        const isInvalid = ref(false);
        const latitude = ref<number>(36.0755227);  // Default latitude
        const longitude = ref<number>(-79.8203066);  // Default longitude
        const address = ref<string>('');
        const showMap = ref<boolean>(false);
        const enteredValue = ref('');
        const clearInputValue = ref(false);
        const showLineItemModal = ref(false);

        const itemSearchedvalue = ref('');
        const deletedItemsIds = ref([]);
        const currenylySelectedState = reactive({
            index: null as any,
            value: null as any
        });
    
        const updateLatitude = (newLatitude: number) => {
            latitude.value = newLatitude;
        };

        const updateLongitude = (newLongitude: number) => {
            longitude.value = newLongitude;
        };
        const customer = reactive({
            // eslint-disable-next-line @typescript-eslint/camelcase
            address_line1: ''

        });
        const signatureInput = ref<HTMLInputElement | null>(null);

        const updateAddress = (newAddress: string) => {
            // eslint-disable-next-line @typescript-eslint/camelcase
            customer.address_line1 = newAddress;


        };


        const state = reactive({
            activeTab: 'projectstb',
            tableData: [] as any,
            selectedRows: [] as any,
            fields: {

            } as any,
            form: {
                firstName: '',
                lastName: '',
                contact: ''
            },
            errors: {
                firstName: '',
                lastName: '',
                contact: '',
            },
            projectId: projectId as any,
            selectedChannel: {
                name: String,
                id: String
            } as any,
            estimationUUId: '' as any,
            selectUnitId: '' as any,
            selectSubItemIndex: '' as any,
            selectItemIndex: '' as any,
            selectSubItem: '' as any,
            selectDeleteItem: '' as any,
            approveByAll: false,
            selectIndex: '' as any,
            selectItemId: '' as any,
            dataFor: '' as any,
            cloningSelectedItem: false,
            selectItems: [

            ] as any,
            showChooseMembers: false,
            data: {
                selectedFilterProjectTab: 'channel',
                selectedFilterCustomerTab: 'channel',
                selectedMembers: [] as any,
                selectedMemberIds: [] as any,
                selectedMemberIdsLocal: [] as any,
                selectedChannelUuid: '',
                selectedProjectUuid: '' as any,
                selectedFilter: 'channel',
                customerToEdit: "" as any,
                customerToEditIndex: "",
                formAddedMembers: [] as any,
                customerChannels: [] as any,
                projectChannels: [] as any,
                customerProjects: [] as any,
                apiChannelMembers: [] as any,
                channelMembers: [] as any,
                removeUser: {} as any,
                haveProfileSign: false,
                useProfileSign: false,
                showSignaturePad: false,
                showSignatureUpload: false,
                showChatChannelModal: false,
                deletedCustomerEmails: [] as string[],
                deletedCustomerPhones: [] as string[],
                uploadSignatureFile: "" as any,
                signatureLink: "" as any,
                cropImage: "",
                newUploadImge: "" as any,
                cropSignature: "" as any,
                note: '',
                selectedCustomers: [] as any,
                allCustomer: [] as any,
                company: "" as any,
                signatureFileName: "" as any,
                details: {} as any,
                inputFrom: 'markUp',
                createDate: moment(new Date()).format("MM-DD-Y"),
                minDate: '',
                searchName: '' as any,
                lineItems: [] as any,
                unitLists: [] as any,
                title: '' as any,
                unit: {
                    name: '',
                    abbreviation: '',
                },
                showSuccesCustomModal: false,
                successFulMessage: '',
                sendarSignature: "" as any,
                uploadSignature: "" as any,
                // eslint-disable-next-line @typescript-eslint/camelcase
                signature_link: '' as any,
                companyInfo: {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_name: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_email: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_phone_number: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    company_address: "",
                    acknowledgement: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    legal_statement: "",
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    logo: "",
                },
            },
            ui: {
                projectChannelPage: 1,
                projectChannelLastPage: 1,
                projectListLastPage: 1,
                projectListPage: 1,
                channelMemberPage: 1,
                channelMemberLastPage: 1,
                channelListPage: 1,
                channelListLastPage: 1,
                channelListHasMore: true,
                isHideChannelPart: false,
                showEditCustomerModal: false,
                searchQuery: {
                    customerChannel: '',
                    channelMembers: '',
                    projects: ''
                },
                isLoading: {
                    customerChannelList: false,
                    customerChannelMemberList: false,
                    projectList: false,
                    projectChannelList: false,
                    isRemoveCustomer: false,
                    geJobEstimationList: false,
                    isEdit: false,
                    getItemList: false,
                    isUnitEdit: false,
                    getUnit: false,
                    addNewSubItem: false,
                    isSaveSend: false,
                    signaturePadLoad: false,
                    isCompanyEdit: false,
                    getData: false,
                },
                isPostLoading: {
                    delete: false,
                    addUnite: false,
                    selectedButton: false,
                    createJobEstimation: false,
                    checkSignature: false,
                    sendJobEstimation: false,
                    createCompanyIfno: false,
                },
                errors: {
                    errorList: {
                        createUnit: [] as any,
                        createJobEstimation: [] as any,
                        createCompanyIfno: [] as any,
                        sendJobEstimation: [] as any,
                    },
                    validationErrorList: {
                        itemName: "",
                        unitName: "",
                        unitAbbreviation: "",
                    },
                    hasError: false,
                    titleError: false
                },
            },
        });


        function readLogo(file: any) {
            const data = {} as any;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                data.file = e.target.result;
                data.filename = file.name.replaceAll(`.${extension}`, "");
                data.extension = extensionLower;
                data.isuploded = false;
                data.size = common.formatBytes(parseInt(file.size));
                state.data.details.logo = data;
            };
            reader.readAsDataURL(file);
        }


        function uploadLogo(event: any) {
            const files = event.target.files || event.dataTransfer.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                // console.log("FILE CHECK >>>", file);
                // if(file.type)
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                readLogo(file);
            }
        }

        function readImage(file: any) {
            const data = {} as any;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                data.file = e.target.result;
                data.name = file.name.replaceAll(`.${extension}`, "");
                data.extension = extensionLower;
                console.log("CHECK DATA FOR UPLOAD>>", data);
                // state.imageList.push(data);
            };
            reader.readAsDataURL(file);
        }
        const dropFiles = (event: any) => {
            const files = event.target.files || event.dataTransfer.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                readImage(file);
            }
        };

        function readSignature(file: any) {
            const data = {} as any;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                data.base64 = e.target.result;
                data.duplicateFile = false; // data.fileName = file.name;
                data.fileName = file.name.replaceAll(`.${extension}`, "");
                data.extension = extensionLower;
                data.isuploded = false;
                data.tag = [] as any;
                data.size = common.formatBytes(parseInt(file.size));
                // state.data.uploadImageData = data;
                state.data.newUploadImge = data.base64;
                state.data.cropImage = data.base64;
                state.data.signatureFileName = data.fileName;
            };
            reader.readAsDataURL(file);
        }

        function onDocumentChange(event: any) {
            const files = event.target.files || event.dataTransfer.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                // console.log("FILE CHECK >>>", file);
                // if(file.type)
                const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const extensionLower = extension.toLowerCase();
                readSignature(file);
                $("#updateUpload").modal("show");
            }
        }

        function showUploadImageModel() {
            $("#updateUpload").modal("show");
        }

        function hideShowUploadImageModel() {
            $("#profileUpdate").val("");
            $("#updateUpload").modal("hide");
        }


        function enableSignaturPad() {

            state.ui.isLoading.signaturePadLoad = !state.ui.isLoading.signaturePadLoad;
        }

        function gotoJobEstimationSend() {
            // router.push({
            //     name: "send-job-estimation",
            //     params: { estimationId: state.estimationUUId },
            // });
            emit('send-job-estimation', state.estimationUUId);
        }

        function gotoJobEstimation() {
            // router.push({
            //     name: "list-job-estimation",
            //     params: { projectId: projectId },
            // });
            emit('back-to-job-estimation-list');
        }

        function deleteItemShow(item: any) {
            state.selectDeleteItem = item;
            $("#deleteItem").modal("show");
        }
        function deleteItemClose() {
            state.selectDeleteItem = '';
            $("#deleteItem").modal("hide");
        }

        function closeSuccessCustomModal() {
            $("#SuccessfulModalCustom").modal("hide");
            if (state.ui.isLoading.isSaveSend) {
                gotoJobEstimationSend()
            } else {
                gotoJobEstimation();
            }
        }

     
        function validationCreateJobEstimation() {
            state.ui.errors.titleError = false;
            state.ui.errors.hasError = false;
            state.ui.errors.errorList.sendJobEstimation = [];

            state.selectItems.forEach((item: any) => {
                item.quantityError = false
                if (!item.quantity) {
                    item.quantityError = true
                    item.isEditing= true
                    state.ui.errors.hasError = true;
                }
            });

            state.selectItems.forEach((item: any) => {
                item.unitError = false
                if (!item.unit) {
                    item.unitError = true
                    item.isEditing = true
                    state.ui.errors.hasError = true;
                }
            });
     

            state.selectItems.forEach((item: any) => {
                item.costError = false
                // Do not accept 0 as a valid cost
                if (item.cost === null || item.cost === undefined || item.cost === '' || Number(item.cost) === 0) {
                    item.costError = true
                    item.isEditing = true
                    state.ui.errors.hasError = true;
                }
            });

            state.selectItems.forEach((item: any) => {
                item.nameError = false
                if (!item?.name) {
                    item.nameError = true
                    item.isEditing = true
                    state.ui.errors.hasError = true;
                }
            });

            if (state.data.selectedCustomers.length == 0) {
                state.ui.errors.errorList.sendJobEstimation.push("Enter one custumer");
            }

            if (!state.data.uploadSignature && !state.data.signatureLink && !state.data.sendarSignature) {
                state.ui.errors.errorList.sendJobEstimation.push("Draw/Upload/ Use your profile Signature");

                state.ui.isPostLoading.checkSignature = true;
            }

            if (
                !state.ui.errors.errorList.sendJobEstimation &&
                !state.ui.errors.errorList.sendJobEstimation.length
            ) {
                state.ui.errors.hasError = false;
            } else if (state.ui.errors.errorList.sendJobEstimation.length != 0) {
                state.ui.errors.hasError = true;
            }

        }


        function usdPriceFormate(data: any) {
            if (data != null) {
                return data.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                });
            }

        }

        function getItemList() {
            state.ui.isLoading.getItemList = true
            state.ui.isLoading.getData = true
            ethitransService
                .getActiveItemList(state.data.searchName)
                .then((res: any) => {
                    state.tableData = [];
                    res.data.data.mainitems.forEach((item: any) => {
                        const childData = [] as any;
                        item.subitems.forEach((subItem: any) => {
                            const subData = {
                                id: subItem.id,
                                name: subItem.name,
                                description: subItem.description,
                                unit: subItem.unit ? subItem.unit.name : '',
                                cost: usdPriceFormate(subItem.cost ? subItem.cost : 0),
                                markup: usdPriceFormate(subItem.markup ? subItem.markup : 0),
                            }
                            childData.push(subData)
                        });
                        const pushData = {
                            id: item.id,
                            name: item.name,
                            description: item.description,
                            unit: item.unit ? item.unit.name : '',
                            cost: usdPriceFormate(item.cost ? item.cost : 0),
                            markup: usdPriceFormate(item.markup ? item.markup : 0),
                            _children: childData,
                        };
                        state.tableData.push(pushData);
                    });
                    res.data.data.mainitems.forEach((item: any) => {
                        item.isChecked = false;
                        item.markup = item.markup ? item.markup : 0;
                        item.cost = item.cost ? item.cost : 0;
                        item.subTotal = item.cost ? item.cost : 0;
                        item.selectUnit = state.data.unitLists.filter((unit: any) => unit.id === item.unit_id)[0];
                        if (item.markup_type == 1) {
                            const parCal = (parseFloat(item.cost) * parseFloat(item.markup)) / 100;
                            item.total = parCal + parseFloat(item.cost);
                        } else {
                            item.total = parseFloat(item.cost) + parseFloat(item.markup);
                        }
                        item.subitems.forEach((subItem: any) => {
                            subItem.isChecked = false;
                            subItem.mainName = item.name;
                            subItem.selectUnit = state.data.unitLists.filter((unit: any) => unit.id === subItem.unit_id)[0];
                            if (subItem.markup_type == 1) {
                                const parCal = (parseFloat(subItem.cost) * parseFloat(subItem.markup)) / 100;
                                subItem.total = parCal + parseFloat(subItem.cost);
                            } else {
                                subItem.total = parseFloat(subItem.cost) + parseFloat(subItem.markup);
                            }
                            subItem.subTotal = subItem.cost ? subItem.cost : 0;
                        });
                    });
                    state.data.lineItems = res.data.data.mainitems;

                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.getItemList = false;
                    state.ui.isLoading.getData = false;
                });
        }
        function checkSubItem(item: any) {
            if (item.subitems) {
                item.subitems.forEach((subItem: any) => {
                    subItem.isChecked = item.isChecked;
                });
            }
        }
        function checkItem(item: any) {
            if (item.subitems) {
                const allChecked = item.subitems.every((subItem: any) => subItem.isChecked);
                item.isChecked = allChecked;
                state.ui.isPostLoading.selectedButton = true;
            }
        }

        function closeSelected(index: any) {
            state.ui.isLoading.getData = true;

            // Get all selected IDs from Tabulator
            const selectedData = tabulator.value.getSelectedData();
            const selectedIds = selectedData.map((item: any) => item.id);
            console.log('selected ids', selectedIds);

            // Step 1: Reset all checks
            state.selectedRows = [];

            state.data.lineItems.forEach((lineItem: any) => {
                lineItem.isChecked = false;
                lineItem.isEditing = true;
                if (lineItem.subitems) {
                    lineItem.subitems.forEach((subItem: any) => {
                        subItem.isChecked = false;
                        lineItem.isEditing = true;
                 });
                }
            });

            // Only set isNew = true for new items, leave existing as is
            selectedData.forEach((selected: any) => {
                state.data.lineItems.forEach((lineItem: any) => {
                    if (lineItem.id === selected.id) {
                        lineItem.isChecked = true;
                        // Only set isNew if not already in selectItems
                        const alreadyExists = state.selectItems.some((item: any) => item.main_item_id === lineItem.id);
                        if (!alreadyExists) {
                            lineItem.isNew = true;
                        }
                        state.selectedRows.push(lineItem.id);
                    }
                    lineItem.subitems.forEach((subItem: any) => {
                        if (subItem.id === selected.id) {
                            subItem.isChecked = true;
                            const alreadyExists = state.selectItems.some((item: any) => item.main_item_id === subItem.id);
                            if (!alreadyExists) {
                                subItem.isNew = true;
                            }
                            state.selectedRows.push(subItem.id);
                        }
                    });
                });
            });

            // Step 3: Remove unchecked items from selectItems
            state.selectItems = state.selectItems.filter((item: any) =>
                selectedIds.includes(item.main_item_id) || Object.keys(item).length === 0 || item.id === 0
            );

            // Step 4: Add newly checked items (only add new, don't update existing)
            state.data.lineItems.forEach((lineItem: any) => {

                lineItem.mainName = '';
                const alreadyExists = state.selectItems.some((item: any) => item.main_item_id === lineItem.id);
                const emptyIndex = state.selectItems.findIndex((item: any) => Object.keys(item).length === 0 || item.id == 0);
                if (emptyIndex !== -1) {
                    state.selectItems.splice(emptyIndex, 1);
                }
                console.log('already', alreadyExists)
                if (lineItem.isChecked && !alreadyExists && lineItem.id != 0) {
                    lineItem.quantity = 1;
                    state.selectItems.push(lineItem);
                }

                lineItem.subitems.forEach((subItem: any) => {
                    subItem.mainName = lineItem.name;
                    const alreadyExists = state.selectItems.some((item: any) => item.main_item_id === subItem.id);
                    const emptyIndex = state.selectItems.findIndex((item: any) => Object.keys(item).length === 0 || item.id == 0);
                    if (emptyIndex !== -1) {
                        state.selectItems.splice(emptyIndex, 1);
                    }

                    if (subItem.isChecked && !alreadyExists && subItem.id != 0) {
                        subItem.quantity = 1;
                        state.selectItems.push(subItem);
                    }
                });
            });


            // Step 6: If nothing selected, show default
            if (state.selectItems.length === 0) {
                state.selectItems = [{
                    id: 0,
                    total: 0,                
                    isEditing: true
                }];
            }

            state.ui.isLoading.getData = false;
            console.log(state.selectItems)

            // Step 7: Close dropdown
            showLineItemModal.value = false
            itemSearchedvalue.value = ''
        }


        function cloneItem(index: any, item: any) {

            state.cloningSelectedItem = true;

            const newItem = cloneDeep(state.selectItems);

            const originalItem = cloneDeep(newItem[index]);
            originalItem.isCopy = true;
            const updatedItems = newItem
                .slice(0, index + 1)
                .concat(originalItem)
                .concat(newItem.slice(index + 1));

            // eslint-disable-next-line @typescript-eslint/camelcase
            state.selectItems = [];
            setTimeout(() => {
                state.selectItems = updatedItems;
                state.cloningSelectedItem = false;
            }, 0);

        }
        function getAllUnits() {

            state.ui.isLoading.getUnit = true
            ethitransService
                .getUnitList()
                .then((res: any) => {
                    state.data.unitLists = res.data.data;

                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.getUnit = false;
                });

        }


        function removeSelectedSubItem(item: any) {

            if (!deletedItemsIds.value) {
                deletedItemsIds.value = [];
            }
            // Add the item to the deletedItems array
            if (item.main_item_id) {
                deletedItemsIds.value.push(item.id as never);
            }

            if (item.main_item_id) {
                state.selectedRows = state.selectedRows.filter((id: any) => id !== item.main_item_id);
            } else {
                state.selectedRows = state.selectedRows.filter((id: any) => id !== item.id);
            }
            
            item.isChecked = false;
            const selectedIndex = common.findIndex(state.selectItems, item);
            if (selectedIndex !== -1) {
                state.selectItems[selectedIndex].isChecked = false;
            }
            state.selectItems = state.selectItems.filter((e: any) => e != item);
            state.selectDeleteItem = '';
            deleteItemClose();
        
        }



        function addMoreSubItems(item: any) {
            if (Object.keys(item).length != 0) {
                state.selectItems.push(JSON.parse(JSON.stringify({ id: 0, total: 0, markup: 0, cost: 0, tableSelected: false, isAllowance: false, isEditing:true })));
            }
        }

        function checkInputNumber(item: any) {
            const data = item.toString().replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
            return data;
        }


        const iconFormatter = (cell: any) => {

            const rows = tabulator.value.getRows();
            for (let i = 0; i < rows.length; i++) {
                const children = rows[i].getTreeChildren();
                for (let j = 0; j < children.length; j++) {
                    const child = children[j].getData();
                    if (state.selectedRows.includes(child['id'])) {
                        children[j].select();
                    }
                }
            }
            tabulator.value.selectRow(state.selectedRows);
            const row = cell.getRow();
            return row.getTreeParent() ? '' : '<i class="fa fa-plus"></i>';

        };
        function addSubItem(data: any) {

            state.selectItemId = data;
            state.dataFor = 'subItem';
            state.ui.isLoading.addNewSubItem = !state.ui.isLoading.addNewSubItem;
            $(`.job-item-dropdown${state.selectIndex}`).dropdown('toggle');
            $(`.job-item-dropdown${state.selectIndex}`).dropdown('hide');
            state.selectIndex = '';
        }



        function resizeTable() {
            if (state.selectItems.length > 0) {
                tabulator.value = new Tabulator(table.value, {

                    height: "311px",
                    layout: "fitColumns",
                    dataTree: true,
                    dataTreeStartExpanded: true,
                    dataTreeFilter: true, //disable child row filtering
                    // getData: true,
                    paginationSize: 20,
                    ajaxURL: `${config.apiBaseUrl}all/item`,
                    progressiveLoad: "scroll",
                    placeholder: "No Data Set",
                    ajaxProgressiveLoad: true,
                    ajaxProgressiveLoadScroll: 20,
                    progressiveLoadDelay: 500,
                    progressiveLoadScrollMargin: 500,
                    ajaxConfig: {
                        method: "GET", //set request type to Position
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("current_user_token")}`,
                        },
                    },
                    columns: [
                        // titleFormatter: "rowSelection",
                        {
                            formatter: "rowSelection", hozAlign: "center", width: 100, headerSort: false, cellClick: function (e: any, cell: any) {
                                cell.getRow().toggleSelect();
                            }
                        },
                        { title: "Name", field: "name", sorter: "string", width: 200, headerFilter: "input", headerFilterPlaceholder: "Find a item..." },
                        { title: "Description", field: "description", width: 300, sorter: "string" },
                        { title: "Unit", field: "unit", sorter: "string" },
                        { title: "Cost", field: "cost", sorter: "string" },
                        { title: "Markup", field: "markup", sorter: "string" },
                        {
                            title: "Action", field: "naiconme", hozAlign: "center", formatter: iconFormatter, cellClick: function (e: any, cell: any) {
                                const row = cell.getRow();
                                const parentId = row.getData().uuid;
                                addSubItem(parentId);
                            },
                            tooltip: function (e: any, cell: any, onRendered: any) {
                                //e - mouseover event
                                //cell - cell component
                                //onRendered - onRendered callback registration function

                                const el = document.createElement("div");
                                el.style.backgroundColor = "white";
                                el.innerText = 'Add a new sub item'

                                return el;
                            },
                        }], //define table columns


                });

            }

        }

        function onToggleChooseItem(index: any) {
            state.selectIndex = '';
            state.selectIndex = index;
            state.ui.isLoading.getData = true;
            state.selectItems[index].tableSelected = true;
            setTimeout(() => {
                resizeTable();
                state.ui.isLoading.getData = false;
            }, 500)
            showLineItemModal.value = true
        }

        
        function calculateTotal(item: any) {
            const selectedIndex = common.findIndex(state.selectItems, item);
            state.selectItems[selectedIndex].cost = checkInputNumber(item.cost ? item.cost : 0);
            state.selectItems[selectedIndex].markup = checkInputNumber(item.markup ? item.markup : 0);
            const total = computed(() => {
                if (item.markup_type == 1) {
                    const prCal = ((state.selectItems[selectedIndex].quantity ? parseFloat(state.selectItems[selectedIndex].quantity) : 0) * (state.selectItems[selectedIndex].cost ? parseFloat(state.selectItems[selectedIndex].cost) : 0) * (state.selectItems[selectedIndex].markup ? parseFloat(state.selectItems[selectedIndex].markup) : 0)) / 100;
                    return prCal + ((state.selectItems[selectedIndex].quantity ? parseFloat(state.selectItems[selectedIndex].quantity) : 0) * (state.selectItems[selectedIndex].cost ? parseFloat(state.selectItems[selectedIndex].cost) : 0));
                } else {

                    return ((state.selectItems[selectedIndex].cost ? parseFloat(state.selectItems[selectedIndex].cost) : 0) * (state.selectItems[selectedIndex].quantity ? parseFloat(state.selectItems[selectedIndex].quantity) : 0)) + (state.selectItems[selectedIndex].markup ? parseFloat(state.selectItems[selectedIndex].markup) : 0);
                }

            });
            state.selectItems[selectedIndex].total = total;
            state.selectItems[selectedIndex].subTotal = ((state.selectItems[selectedIndex].quantity ? parseFloat(state.selectItems[selectedIndex].quantity) : 0) * (state.selectItems[selectedIndex].cost ? parseFloat(state.selectItems[selectedIndex].cost) : 0));
            if (item.isAllowance) {
                state.selectItems[selectedIndex].allowance = state.selectItems[selectedIndex].subTotal;
            }

        }

        function addUnitShow() {
            $("#addUnite").modal("show");
        }
        function addUniteClose() {
            state.ui.errors.validationErrorList.unitName = "";
            state.ui.errors.validationErrorList.unitAbbreviation = "";
            state.data.unit.abbreviation = "";
            state.data.unit.name = "";
            $("#addUnite").modal("hide");
            state.ui.isLoading.isUnitEdit = false;
        }

        function changeMarkupType(index: any, value: any) {
            // eslint-disable-next-line @typescript-eslint/camelcase
            state.selectItems[index].markup_type = value;

            calculateTotal(index);
        }

        function changeUnit(index: any, value: any) {
            console.log(index, value);
            // eslint-disable-next-line @typescript-eslint/camelcase
            state.selectItems[index].unit_id = value.id;
            state.selectItems[index].unit = value;
        }

        function editUnit(item: any) {
            state.data.unit.name = item.name;
            state.data.unit.abbreviation = item.abbreviation;
            state.selectUnitId = item.id;
            state.ui.isLoading.isUnitEdit = true;
            addUnitShow();
        }

        function addNewUnit(item: any) {
            state.selectSubItemIndex = '';
            state.selectSubItemIndex = common.findIndex(state.selectItems, item);
            addUnitShow();
        }

        function deleteUnitList(item: any, unitList: any) {
            state.selectSubItemIndex = '';
            state.selectSubItemIndex = common.findIndex(state.selectItems, item);
            ethitransService
                .deleteUnite(unitList.id)
                .then((res: any) => {
                    if (state.selectItems[state.selectSubItemIndex].selectUnit) {
                        state.selectItems[state.selectSubItemIndex].selectUnit = '';
                    }
                    state.data.unitLists = res.data.data;


                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    // state.ui.isLoading.getUnit = false;
                });

        }

        function deleteUnit(item: any, unitList: any) {
            const result = window.confirm('Do you want to delete?');
            if (result) {
                deleteUnitList(item, unitList);
                console.log('User clicked "Yes"');
            } else {

                console.log('User clicked "No"');
            }
        }


        function createUnitValidation() {
            state.ui.errors.validationErrorList.unitName = "";
            if (!state.data.unit.name) {
                state.ui.errors.validationErrorList.unitName = "Ener valid unit";
                state.ui.errors.hasError = true;
            }
            // if (!state.data.unit.abbreviation) {
            //     state.ui.errors.validationErrorList.unitAbbreviation = "Ener valid abbreviation";
            //     state.ui.errors.hasError = true;
            // }
        }

        function createUnit() {
            state.ui.isPostLoading.addUnite = false;
            state.ui.errors.hasError = false;
            createUnitValidation();
            if (state.ui.isPostLoading.addUnite || state.ui.errors.hasError) return false;
            const payLoad = {

                name: state.data.unit.name,
                abbreviation: state.data.unit.abbreviation,

            };
            state.ui.isPostLoading.addUnite = true;
            ethitransService
                .createUnit(payLoad)
                .then((res: any) => {
                    state.selectItems[state.selectSubItemIndex].unit = res.data.data[0];
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.selectItems[state.selectSubItemIndex].unit_id = res.data.data[0].id;

                    state.data.unitLists = res.data.data;
                })
                .catch((error: any) => {
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createUnit)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createUnit.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.addUnite = false;
                    addUniteClose();

                });
        }

        function updateUnit() {
            state.ui.isPostLoading.addUnite = false;
            state.ui.errors.hasError = false;
            createUnitValidation();
            if (state.ui.isPostLoading.addUnite || state.ui.errors.hasError) return false;
            const payLoad = {

                name: state.data.unit.name,
                abbreviation: state.data.unit.abbreviation,

            };
            state.ui.isPostLoading.addUnite = true;
            ethitransService
                .updateUnit(state.selectUnitId, payLoad)
                .then((res: any) => {
                    state.data.unitLists = res.data.data;

                })
                .catch((error: any) => {
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createUnit)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createUnit.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.addUnite = false;
                    state.selectUnitId = '';
                    addUniteClose();

                });
        }

        const total = computed(() => {

            const total = state.selectItems.reduce((total: any, item: any) => total + item.total, 0);
            return total ? total : 0;

        })


        const totalMarkUP = computed(() => {
            return state.selectItems.reduce((total: any, item: any) => {
                if (item.markup_type == 1) {
                    const tot = total + (parseFloat(item.cost) * parseFloat(item.markup) * parseFloat(item.quantity)) / 100;
                    // return tot ? common.usdPriceFormate(tot) : common.usdPriceFormate(0);
                    return tot ? tot : 0;

                } else {
                    const tot = (total + parseFloat(item.markup));
                    return tot ? tot : 0;
                    // return tot ? common.usdPriceFormate(tot) : common.usdPriceFormate(0);
                }
            }, 0);
        })

        function clearAllJobItem() {
            state.data.lineItems.forEach((item: any) => {
                item.isChecked = false;
                item.subitems.forEach((subItem: any) => {
                    subItem.isChecked = false;
                });
            });
            state.selectItems = [{}];
        }


        function creatJobEstimation() {
            state.ui.isPostLoading.createJobEstimation = false;
            state.ui.errors.hasError = false;
            validationCreateJobEstimation();
            if (state.ui.isPostLoading.createJobEstimation || state.ui.errors.hasError) return false;
            const payLoad = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                project_id: state.projectId,
                items: state.selectItems,
                title: state.data.title,

            };
            state.ui.isPostLoading.createJobEstimation = true;
            ethitransService
                .createJobEstimation(payLoad)
                .then((res: any) => {
                    console.log(res);
                    state.estimationUUId = res.data.data.uuid;
                    state.data.successFulMessage = "Create JobEstimation Successfully.";
                    state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
                })
                .catch((error: any) => {
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createJobEstimation)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createJobEstimation.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.createJobEstimation = false;

                });
        }

        function addNewSubItem(index: any) {
            state.ui.isLoading.addNewSubItem = !state.ui.isLoading.addNewSubItem
            $(`.job-item-dropdown${index}`).dropdown('toggle');
            $(`.job-item-dropdown${index}`).dropdown('hide');
            // $('.job-item-dropdown').dropdown('toggle');
            // $('.job-item-dropdown').dropdown('hide')
        }

        function saveItem() {
            state.ui.isLoading.addNewSubItem = !state.ui.isLoading.addNewSubItem
            getItemList();
            getAllUnits();
        }

        function getJobestimationDetail() {
            state.ui.isLoading.getItemList = true
            ethitransService
                .getJobestimationDetail(props.editId)
                .then((res: any) => {
                    state.selectItems = [];
                    state.data.title = res.data.data.title;
                    state.data.createDate = moment(res.data.data.created_date).format("DD-MM-Y");
                    res.data.data.items.forEach((subItem: any) => {
                        subItem.isChecked = true;
                        subItem.mainName = subItem.main_item_name;
                        subItem.subTotal = parseFloat(subItem.cost) * parseFloat(subItem.quantity);
                        subItem.selectUnit = state.data.unitLists.filter((unit: any) => unit.id === subItem.unit_id)[0];
                        if (subItem.markup_type == 1) {
                            const parCal = ((parseFloat(subItem.cost) * parseFloat(subItem.quantity)) * parseFloat(subItem.markup)) / 100;
                            subItem.total = parCal + (parseFloat(subItem.cost) * parseFloat(subItem.quantity));
                        } else {
                            subItem.total = (parseFloat(subItem.cost) * parseFloat(subItem.quantity)) + parseFloat(subItem.markup);
                        }
                    });

                    state.selectItems = res.data.data.items;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.getItemList = false;
                });
        }

        function updateJobEstimation() {
            state.ui.isPostLoading.createJobEstimation = false;
            state.ui.errors.hasError = false;
            validationCreateJobEstimation();
            if (state.ui.isPostLoading.createJobEstimation || state.ui.errors.hasError) return false;
            const payLoad = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                project_id: state.projectId,
                // eslint-disable-next-line @typescript-eslint/camelcase
                estimation_id: props.editId,
                items: state.selectItems,
                title: state.data.title,

            };
            state.ui.isPostLoading.createJobEstimation = true;
            ethitransService
                .updateJobEstimation(payLoad)
                .then((res: any) => {
                    state.estimationUUId = res.data.data.uuid;
                    state.data.successFulMessage = "Update JobEstimation Successfully.";
                    state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
                })
                .catch((error: any) => {
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createJobEstimation)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createJobEstimation.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.createJobEstimation = false;

                });
        }

        function saveSend() {
            if (state.ui.isLoading.isEdit) {
                state.ui.isLoading.isSaveSend = true;
                updateJobEstimation();
            } else {
                state.ui.isLoading.isSaveSend = true;
                creatJobEstimation();
            }

        }

        onBeforeRouteLeave((to, from) => {
            addUniteClose()
            deleteItemClose()
            $("#SuccessfulModalCustom").modal("hide");
        })
        function updateItem(index: any, newValue: any) {

            state.selectItems[index].cost = newValue.replace(/[$,]/g, '')
        }

        function updateItemMarkup(index: any, newValue: any) {
            state.selectItems[index].markup = newValue.replace(/[$,]/g, '');
        }

        function updateItemAllowance(index: any, newValue: any) {
            state.selectItems[index].allowance = newValue.replace(/[$,]/g, '');
        }

        function fetchCustomerDetails(email: string) {
            ethitransService.detailsByemail(email)
                .then(response => {
                    const selectedCustomers: any = response.data;
                    if (selectedCustomers && selectedCustomers) {
                        const data = selectedCustomers.data;
                        if (data.email) {
                            const customerData = {
                                email: data.email,
                                code: data.email,
                                // eslint-disable-next-line @typescript-eslint/camelcase
                                first_name: data.first_name || '',
                                // eslint-disable-next-line @typescript-eslint/camelcase
                                last_name: data.last_name || '',
                                phone: data.contact_number || '',
                                // eslint-disable-next-line @typescript-eslint/camelcase
                                address_line1: data.address_line1 || '',
                                mailNotification: false,
                                smsNotification: false,
                            };

                            // const existingCustomerIndex = state.data.selectedCustomers.findIndex((customer: any) => customer.email === data.email);
                            // if (existingCustomerIndex !== -1) {
                            //     // Replace the entire object
                            //     state.data.selectedCustomers[existingCustomerIndex] = { ...customerData };
                            // } else {
                            //     state.data.selectedCustomers.push(customerData);
                            // }
                            const existingIndex = state.data.formAddedMembers.findIndex(
                                (m: any) => m.user_id === data.user_id
                            );

                            if (existingIndex !== -1) {
                                state.data.formAddedMembers[existingIndex] = { ...customerData };
                            } else {
                                state.data.formAddedMembers.push(customerData);
                            }

                            // Add to selectedMemberIds if not already selected
                            if (!state.data.selectedMemberIds.includes(data.user_id)) {
                                state.data.selectedMemberIds.push(data.user_id);
                            }
                        }
                    }
                })
                .catch(error => {
                    console.error('Error fetching customer details:', error);
                });
        }
        function addCustomerEmail(data: any) {
            isInvalid.value = false;
            const email = data;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (email == localStorage.getItem("current_user_email")) {
                isInvalid.value = true;
                return false;
            }
            if (!emailRegex.test(email)) {
                isInvalid.value = true;
                return false;
            }
            const existingCustomerIndex = state.data.selectedCustomers.findIndex((customer: any) => customer.email === email);
            if (existingCustomerIndex === -1) {
                const addData = {
                    email: email,
                    code: email,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    first_name: '',
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    last_name: '',
                    phone: '',
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    address_line1: '',
                    mailNotification: true,
                    smsNotification: false,
                };

                state.data.allCustomer.push(addData);
                state.data.selectedCustomers.push(addData);

                // Fetch additional details for the new customer
                fetchCustomerDetails(email);
            } else {
                // If email already exists, update the existing customer details
                fetchCustomerDetails(email);
            }

        }

        // function changeValue() {
        //     isInvalid.value = false;
        // }
        function changeValue(selectedCustomer: any) {
            isInvalid.value = false;
            if (selectedCustomer && selectedCustomer.email) {
                fetchCustomerDetails(selectedCustomer.email);
            }
        }


        const formatCurrency = (value: any) => {
            if (value && typeof value === 'string') {
                const numericValue = parseFloat(value.replace(/[^\d.]/g, '')) || 0;
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });

                return formatter.format(numericValue);
            } else {
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });

                return formatter.format(value);
            }
            // Format as currency using Intl.NumberFormat



        };
        const formatPrice = (index: any) => {
            // Update the price format when the input changes
            state.selectItems[index].cost = formatCurrency(state.selectItems[index].cost);
        };


        function convertValues(obj: any) {
            const convertedObject = {} as any;
            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    convertedObject[key] = obj[key] === 1 ? true : false;
                }
            }
            return convertedObject;

        }

        // Convert values in myObject

        const isEmail = (v: string) => /^[\w.-]+@([\w-]+\.)+[\w-]{2,}$/.test(v);

        function getJobEstimationDetails(uuid: any) {
            state.data.details = {};
            state.data.selectedMemberIds = []
            state.data.formAddedMembers = []
            state.ui.isLoading.geJobEstimationList = true
            ethitransService
                .geJobEstimationDetailsPreview(uuid)
                .then((res: any) => {
                    state.fields = convertValues(res.data.data.fields)
                    state.data.note = res.data.data.note
                    state.data.sendarSignature = res.data.data.signature
                    state.approveByAll = res.data.data.approve_by_all == 1 ? true : false;
                    res.data.data.total = 0;
                    res.data.data.customers.forEach((customer: any) => {
                        // const data = {
                        //     email: customer.email,
                        //     code: customer.email,
                        //     phone: customer.contact_number,
                        //     // eslint-disable-next-line @typescript-eslint/camelcase
                        //     first_name: customer.first_name,
                        //     // eslint-disable-next-line @typescript-eslint/camelcase
                        //     last_name: customer.last_name,
                        //     mailNotification: customer.email_notification,
                        //     smsNotification: customer.sms_notification,
                        //     // eslint-disable-next-line @typescript-eslint/camelcase
                        //     address_line1: customer.address,
                        // };
                        const data = {
                            // eslint-disable-next-line @typescript-eslint/camelcase  
                            user_id: customer.user_id,
                            // eslint-disable-next-line @typescript-eslint/camelcase  
                            user_email: customer.email,
                            // eslint-disable-next-line @typescript-eslint/camelcase  
                            user_first_name: customer.first_name,
                            // eslint-disable-next-line @typescript-eslint/camelcase  
                            user_last_name: customer.last_name,
                            // eslint-disable-next-line @typescript-eslint/camelcase  
                            user_mobile_number: customer.contact_number,
                            // eslint-disable-next-line @typescript-eslint/camelcase  
                            mailNotification: customer.email_notification,
                            // eslint-disable-next-line @typescript-eslint/camelcase  
                            smsNotification: customer.sms_notification,
                            // eslint-disable-next-line @typescript-eslint/camelcase  
                            // isFormAdded: true,
                            // eslint-disable-next-line @typescript-eslint/camelcase  
                            channel_uuid: customer.channel_uuid || res.data.data.channel?.uuid || '',
                            emailFromApi: !!customer.email && isEmail(customer.email),
                            phoneFromApi: !!(customer.contact_number),
                        }
                        state.data.formAddedMembers.push(data)
                        if (!state.data.selectedMemberIds.includes(customer.user_id)) {
                            state.data.selectedMemberIds.push(customer.user_id)
                        }
                        state.data.selectedCustomers.push(data);
                        state.data.selectedMembers.push(data);
                        console.log('The selected costumer data is ', res.data.data.customers
                        )
                    })
                    res.data.data.singed_customers.forEach((customer: any) => {
                        // eslint-disable-next-line @typescript-eslint/camelcase  
                        customer.signaute_date = common.localDateOnly(customer.signaute_date);
                    })
                    // eslint-disable-next-line @typescript-eslint/camelcase  
                    res.data.data.signature_date = common.localDateOnly(res.data.data.signature_date ? res.data.data.signature_date : '');
                    res.data.data.phases.forEach((item: any) => {
                        item.sub_items.forEach((subItem: any) => {
                            subItem.mainName = item.name;
                            subItem.isEditing = true;
                            subItem.selectUnit = state.data.unitLists.filter((unit: any) => unit.id === subItem.unit_id)[0];
                            if (subItem.markup_type == 1) {
                                const parCal = ((parseFloat(subItem.cost) * parseFloat(subItem.quantity)) * parseFloat(subItem.markup)) / 100;
                                subItem.total = parCal + (parseFloat(subItem.cost) * parseFloat(subItem.quantity));
                                res.data.data.total += subItem.total;
                                // subItem.total = common.usdPriceFormate(subItem.total);
                                // subItem.markup = common.takeLimitDigits(subItem.markup ? subItem.markup : 0);
                            } else {
                                subItem.total = (parseFloat(subItem.cost) * parseFloat(subItem.quantity)) + parseFloat(subItem.markup);
                                res.data.data.total += subItem.total;
                                // subItem.total = common.usdPriceFormate(subItem.total);
                                // subItem.markup = common.usdPriceFormate(subItem.markup ? subItem.markup : 0);
                            }
                            subItem.subTotal = (parseFloat(subItem.cost) * parseFloat(subItem.quantity));
                            // subItem.subTotal = common.usdPriceFormate(subItem.subTotal);
                            // subItem.cost = common.usdPriceFormate(subItem.cost);
                            // subItem.allowance = common.usdPriceFormate(subItem.allowance ? subItem.allowance : 0);
                            state.selectItems.push(subItem);
                        });
                    });
                    state.selectedRows = state.selectItems.map((item: any) => item.main_item_id);
                    // res.data.data.total = common.usdPriceFormate(res.data.data.total);
                    state.data.details = res.data.data;
                    state.data.createDate = common.formatDateAndTime(res.data.data.created_date);
                    console.log('The state data details is>>>>>', state.data.createDate);
                    state.selectedChannel = res.data.data.channel;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.geJobEstimationList = false;
                });
        }
        //Watch for changes in the products array and reformat prices
        // watch(state.selectItems, (newProducts: any) => {
        //     newProducts.forEach((product: any, index: any) => {
        //         product.cost = formatCurrency(product.cost);
        //     });
        // });

        function showCreateCompanyModel() {
            $("#addCompanyInfo").modal("show");
        }

        function hideCreateCompanyModel() {
            state.ui.errors.errorList.createCompanyIfno = [];
            $("#addCompanyInfo").modal("hide");
            state.ui.isLoading.isCompanyEdit = false;
        }
        function editCompany() {
            state.ui.isLoading.isCompanyEdit = !state.ui.isLoading.isCompanyEdit;
            $("#addCompanyInfo").modal("show");
        }
        // function showDelete(data: any) {
        //     state.data.allCustomer.length = 0;
        //     return false;
        // }

        function showDelete(customer: any) {
            if (!state.data.deletedCustomerEmails) {
                state.data.deletedCustomerEmails = [];
            }
            const indexInAllCustomer = state.data.allCustomer.findIndex((item: any) => item.email === customer.email);
            const indexInSelectedCustomers = state.data.selectedCustomers.findIndex((item: any) => item.email === customer.email);

            // Remove from allCustomer array if exists
            if (indexInAllCustomer !== -1) {
                state.data.allCustomer.splice(indexInAllCustomer, 1);
            }

            // Remove from selectedCustomers array if exists
            if (indexInSelectedCustomers !== -1) {
                state.data.selectedCustomers.splice(indexInSelectedCustomers, 1);
            }

            state.data.deletedCustomerEmails.push(customer.email);

        }

        function hideDelete() {
            $("#deleteModal").modal("hide");
        }
        function removeCustomer() {
            state.ui.isLoading.isRemoveCustomer = true;
            if (state.data.removeUser != null) {
                const customers = state.data.allCustomer.filter(function (user: any) {
                    return user.email == state.data.removeUser.email;
                })
            }
            state.data.allCustomer.length = 0;
            state.ui.isLoading.isRemoveCustomer = false;
            hideDelete();

        }
        function isEmailValid(item: any) {
            const email = item.email;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (email == localStorage.getItem("current_user_email")) {
                item.emailError = "Owner email  not valid here.";
                return false;
            }
            if (!emailRegex.test(email)) {
                item.emailError = "Please enter valid email.";
                return false;
            }
            item.emailError = "";
            return true;
        }

        function isPhoneValid(item: any) {
            const phone = item.phone;
            const phoneRegex = /^\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
            if (!phoneRegex.test(phone)) {
                item.phoneError = "Please enter valid phone.";
                return false;
            }
            item.phoneError = "";
            return true;
        }

        // function editSelectCustomer(index: number) {
        //     state.data.selectedCustomers.forEach((customer: any) => {
        //         customer.isEdit = false;
        //     });
        //     state.data.selectedCustomers[index].isEdit = true;
        // }

        // function updateSelectCustomer(data: any) {
        //     const item = state.data.selectedCustomers[data];
        //     // eslint-disable-next-line @typescript-eslint/camelcase
        //     item.address_line1 = customer.address_line1 ? customer.address_line1 : item.address_line1;
        //     item.emailError = "";
        //     item.phoneError = "";
        //     if (item.phone) {
        //         if (isEmailValid(item)) {
        //             item.emailError = "";
        //             item.phoneError = "";
        //         }
        //         if (isPhoneValid(item)) {
        //             item.emailError = "";
        //             item.phoneError = "";
        //             item.isEdit = false;
        //         }
        //     } else {
        //         if (isEmailValid(item)) {
        //             item.emailError = "";
        //             item.phoneError = "";
        //             item.isEdit = false;
        //         }
        //     }
        //     if (item.smsNotification) {
        //         if (item.phone == undefined) {
        //             item.phoneError = "Enter phone number.";
        //             item.isEdit = true;
        //         } else if (item.phone.length != 10) {
        //             item.phoneError = "Phone number must be of 10 digit.";
        //             item.isEdit = true;
        //         }

        //     }

        // }
        function removeSelectCustomer(data: any) {
            state.data.selectedCustomers = state.data.selectedCustomers.filter(
                (e: any) => e != data
            );
            hideDelete();
        }

        function validateCreateCompany() {
            // console.log("*** TODO VALIDATION  ***");
            state.ui.errors.hasError = false;
            state.ui.errors.errorList.createCompanyIfno = [];
            if (
                !state.data.companyInfo.company_name &&
                !state.ui.isLoading.isCompanyEdit
            ) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company name is required."
                );
            }
            if (
                !state.data.companyInfo.company_email &&
                !state.ui.isLoading.isCompanyEdit
            ) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company Email is required."
                );
            }
            if (!state.data.companyInfo.logo) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company logo is required."
                );
            }
            if (!state.data.companyInfo.acknowledgement) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company acknowledgement is required."
                );
            }
            // eslint-disable-next-line @typescript-eslint/camelcase
            if (!state.data.companyInfo.legal_statement) {
                state.ui.errors.errorList.createCompanyIfno.push(
                    "Company legal statement is required."
                );
            }
            if (
                !state.ui.errors.errorList.createCompanyIfno &&
                !state.ui.errors.errorList.createCompanyIfno.length
            ) {
                state.ui.errors.hasError = false;
            } else if (state.ui.errors.errorList.createCompanyIfno.length != 0) {
                state.ui.errors.hasError = true;
            }
        }
        //no profile set
        function createCompanyIfno() {
            state.ui.errors.errorList.createCompanyIfno = [];
            state.ui.errors.hasError = false;

            validateCreateCompany();

            if (state.ui.isPostLoading.createCompanyIfno) return false;
            if (
                state.ui.errors.hasError ||
                state.ui.errors.errorList.createCompanyIfno.length != 0
            )
                return false;

            if (state.ui.isLoading.isCompanyEdit) {
                hideCreateCompanyModel();
            }
            const payLoad: any = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                company_name: state.data.companyInfo.company_name,
                // eslint-disable-next-line @typescript-eslint/camelcase
                logo: state.data.companyInfo.logo,
                // eslint-disable-next-line @typescript-eslint/camelcase
                company_phone_number: state.data.companyInfo.company_phone_number,
                // eslint-disable-next-line @typescript-eslint/camelcase
                company_email: state.data.companyInfo.company_email,
                // eslint-disable-next-line @typescript-eslint/camelcase
                acknowledgement: state.data.companyInfo.acknowledgement,
                // eslint-disable-next-line @typescript-eslint/camelcase
                legal_statement: state.data.companyInfo.legal_statement,
            };
            state.ui.isPostLoading.createCompanyIfno = true;
            ethitransService
                .updateCompanyInfo(payLoad)
                .then((res: any) => {
                    hideCreateCompanyModel();
                })
                .catch((error: any) => {
                    console.log(error);
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createCompanyIfno)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createCompanyIfno.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.createCompanyIfno = false;
                });
        }

        function validateSendInvitation() {
            state.ui.errors.errorList.sendJobEstimation = [];
            state.ui.errors.hasError = false;

          
        }

        const channelMembers = computed(() => {
            const selectedChannel = state.data.selectedChannelUuid;

            const editedIds = new Set(
                state.data.formAddedMembers
                    .filter((m: any) => m.channel_uuid === selectedChannel)
                    .map((m: any) => m.user_id)
            );

            const filteredApiMembers = state.data.apiChannelMembers.filter(
                (m: any) => !editedIds.has(m.user_id)
            );

            const formAddedFiltered = state.data.formAddedMembers.filter(
                (m: any) => m.channel_uuid === selectedChannel
            );

            return [...filteredApiMembers, ...formAddedFiltered];
        });


        // const selectedMembers = computed(() => {
        //     return channelMembers.value.filter((member: any) =>
        //         state.data.selectedMemberIds.includes(member.user_id)
        //     )
        // })
        const selectedMembers = computed(() => {
            return state.data.selectedMembers
        })

        function sendJobEstimation() {
            state.ui.isPostLoading.sendJobEstimation = false;
            state.ui.errors.hasError = false;
            // if (!signaturePad.isEmpty() && signaturePad.toData()) {
            //     state.data.uploadSignature = signaturePad.toDataURL();
            // } else if (cropper?.getDataURL()) {
            //     state.data.uploadSignature = cropper?.getDataURL();
            // } else {
            //     state.data.uploadSignature = "";
            //     // eslint-disable-next-line @typescript-eslint/camelcase
            //     state.data.signature_link = state.data.sendarSignature;
            // }
            if (!state.data.signatureLink && state.data.sendarSignature) {
                state.data.signatureLink = state.data.sendarSignature;
            }
            validationCreateJobEstimation();
            if (state.ui.isPostLoading.sendJobEstimation || state.ui.errors.hasError) return;
            // const selectedCustomer = [] as any;
            const newItem = [] as any;
            const oldItem = [] as any;
            state.selectItems.forEach((item: any) => {
                if (item.isNew || item.isCopy) {
                    newItem.push(item);
                } else {
                    oldItem.push(item);
                }
            });
            // state.data.selectedCustomers.forEach((customer: any) => {
            //     selectedCustomer.push(customer.email);
            // });
            // state.data.selectedCustomers.forEach((customer: any) => {
            //     selectedCustomer.push(customer);
            // });
            const selectedCustomer = selectedMembers.value.map((customer: any) => ({
                // eslint-disable-next-line @typescript-eslint/camelcase
                email: customer.user_email || customer.email || '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                code: customer.user_email || customer.email || '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                first_name: customer.user_first_name || customer.first_name || '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                last_name: customer.user_last_name || customer.last_name || '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                phone: common.filterAndFormatUSPhoneNumber(customer.user_mobile_number || customer.phone || ''),
                // eslint-disable-next-line @typescript-eslint/camelcase
                address_line1: customer.address_line1 || '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                mailNotification: customer.mailNotification ?? false,
                smsNotification: customer.smsNotification ?? false
            }));
            const { id, name } = state.selectedChannel;
            const payLoad: Record<string, any> = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                estimation_id: props.editId,
                fields: state.fields,
                // eslint-disable-next-line @typescript-eslint/camelcase
                approve_by_all: state.approveByAll,
                customers: selectedCustomer,
                signature: state.data.uploadSignature,
                items: oldItem,
                // eslint-disable-next-line @typescript-eslint/camelcase
                new_item: newItem,
                // eslint-disable-next-line @typescript-eslint/camelcase
                signature_link: state.data.signatureLink,
                note: state.data.note,
                // eslint-disable-next-line @typescript-eslint/camelcase
                deleted_customer_emails: state.data.deletedCustomerEmails,
                // eslint-disable-next-line @typescript-eslint/camelcase
                deleted_customer_phones: state.data.deletedCustomerPhones,
                acknowledgement: state.data.details.acknowledgement,
                // eslint-disable-next-line @typescript-eslint/camelcase
                legal_statement: state.data.details.legal_statement,
                logo: state.data.details.logo,
                // eslint-disable-next-line @typescript-eslint/camelcase
                ...(id ? { channel_id: id } : { channel_name: name }),
                // eslint-disable-next-line @typescript-eslint/camelcase
                deleted_item_ids: deletedItemsIds.value
            };

            state.ui.isPostLoading.sendJobEstimation = true;
            ethitransService
                .sendJobEstimation(payLoad)
                .then((res: any) => {
                    console.log(res);
                    state.data.successFulMessage = "Send JobEstimation Successfully.";
                    state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
                    deletedItemsIds.value = [];
                })
                .catch((error: any) => {
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.sendJobEstimation)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.sendJobEstimation.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.sendJobEstimation = false;

                });
        }

        function userStatus() {

            const payLoad = {
                email: localStorage.getItem("current_user_email"),
            };
            ethitransService
                .userStatus(payLoad)
                .then((res: any) => {
                    state.data.companyInfo.logo = res.data.data.company.logo;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.company_name = res.data.data.company.company_name;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.company_phone_number = res.data.data.company.company_phone_number;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.company_email = res.data.data.company.company_email;
                    state.data.companyInfo.acknowledgement = res.data.data.company.acknowledgement;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.legal_statement = res.data.data.company.legal_statement;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.data.companyInfo.company_address = res.data.data.company.company_address;
                    // console.log("User Detail Check:>>> ", res.data.data);
                })
                .catch((error: any) => {
                    //   common
                    //     .sdCatchErr(error, state.ui.error.errorsList)
                    //     .then((res: any) => {
                    //       state.ui.error.hasError = true;
                    //       // console.log("CHECK for Error >>>", res)
                    //       for (const [key, value] of Object.entries(res)) {
                    //         if (Array.isArray(value)) {
                    //           state.ui.error.errorsList.push(value[0]);
                    //         }
                    //       }
                    //       // if (res) {
                    //       //   if (res.error) {
                    //       //     console.log("CHECK for Error >>>", res.error[0])
                    //       //     // state.errorList.push(res.email[0]);
                    //       //     // state.errorList = [...state.errorList]
                    //       //   }
                    //       // }
                    //     });
                })
                .finally(() => {
                    //   state.ui.isLoading.userStatus = true;
                });
        }

        const applyFilter = () => {
            if (state.data.searchName === '') {
                // If filter is empty, reset to original data
                tabulator.value.setData(state.tableData);
            } else {
                const currentData = tabulator.value.getData();
                const filteredData = currentData.filter((row: any) =>
                    Object.values(row).some((value) =>
                        String(value).toLowerCase().includes(state.data.searchName.toLowerCase())
                    )
                );
                tabulator.value.setData(filteredData);
            }
        };

        function clearSignature() {
            state.data.uploadSignature = "";
            state.data.cropSignature = "";
            state.data.sendarSignature = "";

        }
        function showSignaturePad() {
            state.data.showSignaturePad = !state.data.showSignaturePad;
        }

        function hideSignaturePad() {
            state.data.showSignaturePad = !state.data.showSignaturePad;
            $("#signaturePadModal").modal("hide");
        }

        // function hideSignatureUpload() {
        //     state.data.showSignatureUpload = false;
        //     $("#signatureUploadModal").modal("hide");
        // }
        function hideSignatureUpload() {
            state.data.showSignatureUpload = false;
            if (signatureInput.value) {
                signatureInput.value.value = '';
            }
        }
        function uploadSignature(data: any) {
            state.data.uploadSignature = data;
            state.data.signatureLink = "";
            state.data.cropSignature = data;
            state.data.useProfileSign = false;
        }

        // function uploadSignatureFile(event: any) {
        //     state.data.showSignatureUpload = true;
        //     state.data.uploadSignatureFile = event.target.files || event.dataTransfer.files;
        // }
        function uploadSignatureFile(event: any) {
            const files = event.target.files || event.dataTransfer.files;
            if (files && files.length > 0) {
                state.data.uploadSignatureFile = files;
                state.data.showSignatureUpload = true;
                nextTick(() => {
                    if (signatureInput.value) {
                        signatureInput.value.value = '';
                    }
                });
            }
        }

        function userSignature(from: any) {
            ethitransService
                .userSignature()
                .then((res: any) => {
                    if (from == 'onMount' && res.data.data.signature) {
                        state.data.haveProfileSign = true;
                    }
                    if (from == 'use' && res.data.data.signature) {
                        state.data.useProfileSign = true;
                        state.data.uploadSignature = "";
                        state.data.cropSignature = res.data.data.signature;
                        state.data.signatureLink = res.data.data.signature;
                    }
                })
                .catch((error: any) => {
                    //   common
                })
                .finally(() => {
                    //   state.ui.isLoading.userStatus = true;
                });
        }
        const handleCheckboxChange = (item: any, index: any, event: any) => {
            console.log("HELLO >>> ", item);
            console.log("INDEX >>> ", index);
            console.log("EVEN CHECK  >>> ", event);
            // Set the isChecked property based on the checkbox state
            item.isAllowance = event.target.checked;

            // If checked, set the Allowance to subTotal
            if (item.isAllowance) {
                state.selectItems[index].allowance = item.subTotal;
                state.selectItems[index].isAllowance = event.target.checked;
            } else {
                // Optionally, reset Allowance if unchecked (you can define your own behavior here)
                state.selectItems[index].allowance = 0;
                state.selectItems[index].isAllowance = event.target.checked;
            }
        };
        function redirectToChat() {
            state.data.showChatChannelModal = !state.data.showChatChannelModal;
        }

        function hideChatChannel() {
            state.data.showChatChannelModal = !state.data.showChatChannelModal;
        }
        const handleChannelSelection = (channel: any) => {
            state.selectedChannel = channel;
        };


        function projectMembersList(uuid: string, isLoadMore = false) {
            console.log('Project Memberlist Project UUID is>>>', uuid);
            state.ui.isLoading.customerChannelMemberList = true
            ethitransService
                .projectMembersList(uuid)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const members = response.data || [];
                    if (members && members.length) {
                        state.ui.isHideChannelPart = true;
                    }
                    const taggedMembers = members.map((member: any) => ({
                        ...member,
                        emailFromApi: !!member.user_email && isEmail(member.user_email),
                        phoneFromApi: !!(member.user_mobile_number || member.user_phone),
                    }));


                    if (isLoadMore) {
                        // Prepend new members at the top
                        state.data.apiChannelMembers = [...taggedMembers, ...state.data.apiChannelMembers];
                    } else {
                        state.data.apiChannelMembers = taggedMembers;
                    }

                    // Save pagination info
                    state.ui.channelMemberPage = response.current_page;
                    state.ui.channelMemberLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    // customerChannelList();
                    state.ui.isLoading.customerChannelMemberList = false;
                });

        }

        function selectCustomerChannel(channelId = '', searchQuery = '', page = 1, isLoadMore = false) {
            // state.data.apiChannelMembers = [];
            state.ui.isLoading.customerChannelMemberList = true;
            state.data.selectedChannelUuid = channelId;
            console.log('The state.data.selectedChannelUuid::', state.data.selectedChannelUuid)
            ethitransService.customerChannelMemberList(channelId, searchQuery, 10, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const members = response.data || [];
                    const taggedMembers = members.map((member: any) => ({
                        ...member,
                        emailFromApi: !!member.user_email && isEmail(member.user_email),
                        phoneFromApi: !!(member.user_mobile_number || member.user_phone),
                    }));

                    if (isLoadMore) {
                        // Prepend new members at the top
                        state.data.apiChannelMembers = [...state.data.apiChannelMembers, ...taggedMembers];
                    } else {
                        state.data.apiChannelMembers = taggedMembers;
                    }

                    // Save pagination info
                    state.ui.channelMemberPage = response.current_page;
                    state.ui.channelMemberLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.customerChannelMemberList = false;
                });
        }


        function customerChannelList(searchQuery = '', perPage = 10, page = 1, isLoadMore = false) {

            state.ui.isLoading.customerChannelList = true;
            ethitransService.customerChannelList(projectId as any, searchQuery, perPage, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const channels = response.data || [];
                    console.log('Fetched Customer Channels:', channels);

                    if (isLoadMore) {
                        state.data.customerChannels = [...state.data.customerChannels, ...channels];
                    } else {
                        state.data.customerChannels = channels;
                        if (channels.length > 0) {
                            const firstChannelUuid = channels[0].uuid;
                            selectCustomerChannel(firstChannelUuid);
                            state.ui.isHideChannelPart = false;
                        }
                    }

                    // Save pagination info
                    state.ui.channelListLastPage = response.last_page;
                    state.ui.channelListPage = response.current_page;

                })
                .catch((error: any) => {
                    console.error('Error fetching customer channels:', error);
                })
                .finally(() => {
                    state.ui.isLoading.customerChannelList = false;
                });
        }


        function projectChannelList(projectId = '', searchQuery = '', perPage = 10, page = 1, isLoadMore = false) {
            console.log('Project UUID is:', projectId);
            state.ui.isLoading.projectChannelList = true;
            state.data.selectedProjectUuid = projectId;
            state.data.projectChannels = [],

                ethitransService.projectChannelList(projectId, searchQuery, perPage, page)
                    .then((res: any) => {
                        const response = res.data.data || {};
                        const channels = response.data || [];
                        console.log('Fetched Project Channels:', channels);

                        if (isLoadMore) {
                            // Prepend new items at the top
                            state.data.projectChannels = [...state.data.projectChannels, ...channels];
                        } else {
                            state.data.projectChannels = channels;

                            if (channels.length > 0) {
                                const firstChannelUuid = channels[0].uuid;
                                selectCustomerChannel(firstChannelUuid);
                                state.ui.isHideChannelPart = false;
                            }
                        }

                        // Save pagination info
                        state.ui.projectChannelPage = response.current_page;
                        state.ui.projectChannelLastPage = response.last_page;
                    })
                    .catch((error: any) => {
                        console.error('Error fetching project channels:', error);
                    })
                    .finally(() => {
                        state.ui.isLoading.projectChannelList = false;
                    });
        }


        function customerProjectList(searchQuery = '', perPage = 10, page = 1, isLoadMore = false) {
            console.log('Search Query:', searchQuery);
            state.ui.isLoading.projectList = true;

            ethitransService.customerProjectList(searchQuery, perPage, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const projects = response.data || [];

                    console.log('Fetched Project List:', projects);

                    if (isLoadMore) {
                        // Prepend new items to the top
                        state.data.customerProjects = [...state.data.customerProjects, ...projects];
                    } else {
                        state.data.customerProjects = projects;

                        if (projects.length > 0) {
                            const firstProjectUuid = projects[0].uuid;
                            state.data.selectedProjectUuid = firstProjectUuid;
                            projectChannelList(firstProjectUuid);
                            state.ui.isHideChannelPart = false;
                        }
                    }

                    // Save pagination
                    state.ui.projectListPage = response.current_page;
                    state.ui.projectListLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.error('Error fetching customer projects:', error);
                })
                .finally(() => {
                    state.ui.isLoading.projectList = false;
                });
        }


        // function removeSelectedMember(userId: number) {
        //     state.data.selectedMemberIds = state.data.selectedMemberIds.filter((id: any) => id !== userId)

        //     state.data.channelMembers = state.data.channelMembers.filter((member: any) => {
        //         return !(member.user_id === userId && member.isFormAdded)
        //     })
        // }

        function removeSelectedMember(userId: number) {
            if (!state.data.deletedCustomerEmails) {
                state.data.deletedCustomerEmails = [];
            }
            if (!state.data.deletedCustomerPhones) {
                state.data.deletedCustomerPhones = [];
            }

            // Find and remove from selectedMembers
            const removedMember = state.data.selectedMembers.find((m: any) => m.user_id === userId);

            if (removedMember) {
                const emailToDelete = removedMember.user_email || removedMember.email;
                if (emailToDelete && !state.data.deletedCustomerEmails.includes(emailToDelete)) {
                    state.data.deletedCustomerEmails.push(emailToDelete);
                }

                const phoneToDelete = removedMember.user_mobile_number || removedMember.phone;
                if (phoneToDelete && !state.data.deletedCustomerPhones.includes(phoneToDelete)) {
                    state.data.deletedCustomerPhones.push(phoneToDelete);
                }
            }

            // Remove from selection arrays
            state.data.selectedMemberIds = state.data.selectedMemberIds.filter((id: any) => id !== userId);
            state.data.selectedMemberIdsLocal = state.data.selectedMemberIdsLocal.filter((id: any) => id !== userId);
            state.data.selectedMembers = state.data.selectedMembers.filter((m: any) => m.user_id !== userId);
        }
        function projectMembersListAll(searchQuery = '', page = 1, isLoadMore = false) {
            // state.data.apiChannelMembers = [];
            state.ui.isLoading.customerChannelMemberList = true
            ethitransService
                .customerChannelMemberListAll(searchQuery, 10, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const members = response.data || [];
                    const taggedMembers = members.map((member: any) => ({
                        ...member,
                        emailFromApi: !!member.user_email && isEmail(member.user_email),
                        phoneFromApi: !!(member.user_mobile_number || member.user_phone),
                    }));


                    if (isLoadMore) {
                        // Prepend new members at the top
                        state.data.apiChannelMembers = [...state.data.apiChannelMembers, ...taggedMembers];
                    } else {
                        state.data.apiChannelMembers = taggedMembers;
                    }

                    // Save pagination info
                    state.ui.channelMemberPage = response.current_page;
                    state.ui.channelMemberLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    // customerChannelList();
                    state.ui.isLoading.customerChannelMemberList = false;
                });

        }
        function resetMemberPagination() {
            state.ui.channelMemberPage = 1;
            state.ui.channelMemberLastPage = 1;
        }

        const debouncedCustomerChannel = useDebouncedRef('', 700, (val) => {
            customerChannelList(val)
        })

        const debouncedChannelMembers = useDebouncedRef('', 700, (val) => {
            selectCustomerChannel(state.data.selectedChannelUuid, val)
        })

        const debouncedProjects = useDebouncedRef('', 700, (val) => {
            customerProjectList(val)
        })

        const debouncedProjectChannel = useDebouncedRef('', 700, (val) => {
            projectChannelList(state.data.selectedProjectUuid, val)
        })
        const debouncedMemberSearch = useDebouncedRef('', 700, (val) => {
            if (state.data.selectedFilterCustomerTab === 'member') {
                resetMemberPagination();
                projectMembersListAll(val);
            } else {
                selectCustomerChannel(state.data.selectedChannelUuid, val);
            }
        })

        function clearAllSearchInputs() {
            debouncedCustomerChannel.value = ''
            debouncedChannelMembers.value = ''
            debouncedProjects.value = ''
            debouncedProjectChannel.value = ''
            debouncedMemberSearch.value = ''
        }


        function handleFilterChange() {
            clearAllSearchInputs()
            if (state.data.selectedFilterProjectTab === 'channel') {
                customerChannelList();
            } else if (state.data.selectedFilterProjectTab === 'member') {
                projectMembersList(state.projectId);
            }
        }


        function handleFilterChangeAll() {
            clearAllSearchInputs()
            if (state.data.selectedFilterCustomerTab === 'channel') {
                state.data.channelMembers = [];
                state.ui.isHideChannelPart = false;
                customerProjectList();
            } else if (state.data.selectedFilterCustomerTab === 'member') {
                state.data.apiChannelMembers = [];
                state.data.selectedChannelUuid = '';
                state.ui.isHideChannelPart = true;
                projectMembersListAll();
            }
        }
        function allCustomerChannelList(searchQuery = '') {
            console.log('allCustomerChannelList API called:');
            state.ui.isLoading.customerChannelList = true;

            ethitransService.allCustomerChannelList(searchQuery)
                .then((res: any) => {
                    const channels = res.data.data.data || [];
                    console.log('Fetched Customer Channels:', channels);

                    state.data.customerChannels = channels;

                    if (channels.length > 0) {
                        const firstChannelUuid = channels[0].uuid;

                        state.data.apiChannelMembers = [];
                        selectCustomerChannel(firstChannelUuid);

                        state.ui.isHideChannelPart = false;
                    }
                })
                .catch((error: any) => {
                    console.error('Error fetching customer channels:', error);
                })
                .finally(() => {
                    state.ui.isLoading.customerChannelList = false;
                });
        }



        function resetForm() {
            state.form.firstName = ''
            state.form.lastName = ''
            state.form.contact = ''
        }
        const formatMobileNumber = (number: string) => {
            return `+1 (${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
        };


        const isPhone = (v: string) => /^\d{10}$/.test(v) || /^\+1 \(\d{3}\) \d{3}-\d{4}$/.test(v);
        const formatPhone = (n: string) => `+1 (${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}`;

        const validate = () => {
            const f = state.form;
            state.errors.firstName = f.firstName.trim() ? '' : 'First name is required.';
            state.errors.lastName = f.lastName.trim() ? '' : 'Last name is required.';
            const c = f.contact.trim();
            state.errors.contact = !c
                ? 'Email or phone is required.'
                : !isEmail(c) && !isPhone(c)
                    ? 'Invalid email or phone.'
                    : '';
            return !state.errors.firstName && !state.errors.lastName && !state.errors.contact;
        };
        function cleanPhone(phone: string): string {
            return phone.replace(/\D/g, ''); // Remove everything except digits
        }


        const addCustomer = () => {
            if (!validate()) return;

            const contact = state.form.contact.trim();
            const formatted = /^\d{10}$/.test(contact) ? formatPhone(contact) : contact;

            const isEmailContact = isEmail(formatted);
            const isDuplicate = state.data.selectedMembers.some((member: any) => {
                const existing = isEmailContact
                    ? member.user_email?.toLowerCase()
                    : cleanPhone(member.user_mobile_number || '');
                const input = isEmailContact
                    ? formatted.toLowerCase()
                    : cleanPhone(formatted);
                return existing === input;
            });

            if (isDuplicate) {
                state.errors.contact = 'This contact is already selected.';
                return;
            }

            const customer = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_id: Date.now(),
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_first_name: state.form.firstName.trim(),
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_last_name: state.form.lastName.trim(),
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_email: isEmailContact ? formatted : '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_mobile_number: isEmailContact ? '' : formatted,
                isFormAdded: true,
                mailNotification: isEmailContact,
                smsNotification: !isEmailContact,
            };

            state.data.formAddedMembers.push(customer);
            state.data.selectedMemberIds.push(customer.user_id);
            state.data.selectedMembers.push(customer);

            // Reset form and errors
            state.form.firstName = '';
            state.form.lastName = '';
            state.form.contact = '';
            (Object.keys(state.errors) as Array<keyof typeof state.errors>).forEach(
                key => state.errors[key] = ''
            );

            clearInputValue.value = false;
            nextTick(() => {
                clearInputValue.value = true;
            });
        };


        // function toggleMemberSelection(userId: number, event: Event) {
        //     const isChecked = (event.target as HTMLInputElement).checked

        //     if (isChecked) {
        //         if (!state.data.selectedMemberIds.includes(userId)) {
        //             state.data.selectedMemberIds.push(userId)
        //         }
        //     } else {
        //         // Unchecked → remove from selected
        //         removeSelectedMember(userId)
        //     }
        // }
        function toggleMemberSelection(userId: number, event: Event) {
            const isChecked = (event.target as HTMLInputElement).checked
            const member = channelMembers.value.find((m: any) => m.user_id === userId)
                || state.data.formAddedMembers.find((m: any) => m.user_id === userId)
            console.log('The member is  ', member)
            if (!member) return

            if (isChecked) {
                if (!state.data.selectedMemberIds.includes(userId)) {
                    state.data.selectedMemberIds.push(userId)

                    const exists = state.data.selectedMembers.some((m: any) => m.user_id === member.user_id)
                    if (!exists) {
                        // Clone the member and set notification flags based on presence of email/phone
                        const selectedMember = {
                            ...member,
                            mailNotification: !!isEmail(member.user_email),
                            smsNotification: !!member.user_mobile_number,
                        }
                        state.data.selectedMembers.push(selectedMember)
                    }
                }
            } else {
                removeSelectedMember(userId)
            }
        }
        // function toggleMemberSelection(userId: number, event: Event) {
        //     const isChecked = (event.target as HTMLInputElement).checked;

        //     const member =
        //         channelMembers.value.find((m: any) => m.user_id === userId) ||
        //         state.data.formAddedMembers.find((m: any) => m.user_id === userId);

        //     if (!member) return;

        //     if (isChecked) {
        //         if (!state.data.selectedMemberIds.includes(userId)) {
        //             state.data.selectedMemberIds.push(userId);
        //         }
        //         if (!state.data.selectedMemberIdsLocal.includes(userId)) {
        //             state.data.selectedMemberIdsLocal.push(userId);
        //         }
        //         const exists = state.data.selectedMembers.some((m: any) => m.user_id === member.user_id);
        //         if (!exists) {
        //             const selectedMember = {
        //                 ...member,
        //                 mailNotification: !!isEmail(member.user_email),
        //                 smsNotification: !!member.user_mobile_number,
        //             };
        //             state.data.selectedMembers.push(selectedMember);
        //         }

        //         const existsInForm = state.data.formAddedMembers.some((m: any) => m.user_id === member.user_id);
        //         if (!existsInForm) {
        //             state.data.formAddedMembers.push({ ...member });
        //         }

        //     } else {
        //         removeSelectedMember(userId);
        //         state.data.selectedMemberIds = state.data.selectedMemberIds.filter((id: any) => id !== userId);
        //         state.data.selectedMemberIdsLocal = state.data.selectedMemberIdsLocal.filter((id: any) => id !== userId);
        //     }
        // }



        // function onChannelSearchInput(e: Event) {
        //     const value = (e.target as HTMLInputElement).value.trim();
        //     if (value === '') {
        //         state.ui.channelListPage = 1;
        //         state.ui.channelListLastPage = 1;
        //         customerChannelList(state.ui.searchQuery.customerChannel, 10, 1)
        //     }
        // }
        function onChannelSearchInput(e: Event) {
            const value = (e.target as HTMLInputElement).value.trim();
            state.ui.channelListPage = 1;
            state.ui.channelListLastPage = 1;
            const selectedProjectUuid = state.data.selectedProjectUuid;
            if (selectedProjectUuid) {
                projectChannelList(selectedProjectUuid, value, 10, 1);
            }
        }
        function editSelectCustomer(member: any) {
            console.log('The customer is>>', member)
            state.data.customerToEdit = {
                ...member,
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_email: isEmail(member.user_email) ? member.user_email : '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                user_phone: member.user_phone || member.user_mobile_number || '',
                // eslint-disable-next-line @typescript-eslint/camelcase
                isEmailDisabled: member.emailFromApi && !!member.user_email,
                // eslint-disable-next-line @typescript-eslint/camelcase
                isPhoneDisabled: member.phoneFromApi && !!(member.user_phone || member.user_mobile_number),
            }
            // document.body.style.overflow = 'hidden'
            state.ui.showEditCustomerModal = true;
        }
        function closeEditCustomerModal() {
            state.ui.showEditCustomerModal = false;
            state.data.customerToEdit = null;
            // document.body.style.overflow = ''
        }

        function onChannelMemberSearchInput(e: Event) {
            const value = (e.target as HTMLInputElement).value.trim();
            if (value === '') {
                state.ui.projectChannelPage = 1;
                state.ui.projectChannelLastPage = 1;
                projectChannelList(state.data.selectedProjectUuid);
            }
        }
        function onProjectSearchInput(e: Event) {
            const value = (e.target as HTMLInputElement).value.trim();
            if (value === '') {
                state.ui.projectListPage = 1;
                state.ui.projectListLastPage = 1;
                customerProjectList('', 10, 1);
            }
        }
        function handleChannelScroll(event: any) {
            const element = event.target;

            if (element.scrollTop + element.clientHeight >= element.scrollHeight) {
                // Load more only if not loading and more pages available
                if (state.ui.channelListPage < state.ui.channelListLastPage && !state.ui.isLoading.customerChannelList) {
                    customerChannelList(
                        state.ui.searchQuery.customerChannel,
                        10,
                        state.ui.channelListPage + 1,
                        true
                    );
                }
            }
        }


        function handleChannelMemberScroll(event: any) {
            const el = event.target;

            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                if (
                    state.ui.channelMemberPage < state.ui.channelMemberLastPage &&
                    !state.ui.isLoading.customerChannelMemberList
                ) {
                    const nextPage = state.ui.channelMemberPage + 1;
                    selectCustomerChannel(
                        state.data.selectedChannelUuid,
                        state.ui.searchQuery.channelMembers,
                        nextPage,
                        true
                    );
                }
            }
        }

        const handleProjectScroll = async (event: Event) => {
            const el = event.target as HTMLElement;
            const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;
            if (
                isAtBottom &&
                state.ui.projectListPage < state.ui.projectListLastPage &&
                !state.ui.isLoading.projectList
            ) {
                await nextTick();

                if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                    const nextPage = state.ui.projectListPage + 1;
                    customerProjectList(
                        state.ui.searchQuery.projects,
                        10,
                        nextPage,
                        true
                    );
                }
            }
        };


        function handleProjectChannelScroll(event: any) {
            const el = event.target;

            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                if (
                    state.ui.projectChannelPage < state.ui.projectChannelLastPage &&
                    !state.ui.isLoading.projectChannelList
                ) {
                    const nextPage = state.ui.projectChannelPage + 1;
                    projectChannelList(
                        state.data.selectedProjectUuid,
                        state.ui.searchQuery.customerChannel,
                        10,
                        nextPage,
                        true
                    );
                }
            }
        }

        const handleInput = (value: string) => {
            enteredValue.value = value;
            state.form.contact = value;
            // errorMessage.value = '';
        };
        function updateSelectCustomer() {
            const customer = state.data.customerToEdit;
            if (!customer) return;
            let hasError = false;

            // Clear previous errors
            customer.mailNotificationError = '';
            customer.smsNotificationError = '';
            customer.firstNameNotificationError = '';
            customer.lastNameNotificationError = '';

            if (!customer.user_first_name || !customer.user_first_name.trim()) {
                customer.firstNameNotificationError = 'First name is required.';
                hasError = true;
            }

            if (!customer.user_last_name || !customer.user_last_name.trim()) {
                customer.lastNameNotificationError = 'Last name is required.';
                hasError = true;
            }

            if (customer.mailNotification) {
                if (!customer.user_email) {
                    customer.mailNotificationError = 'Email is required when notify by email is selected.';
                    hasError = true;
                } else if (!isEmail(customer.user_email)) {
                    customer.mailNotificationError = 'Invalid email format.';
                    hasError = true;
                }
            }

            // Validate phone if notify by SMS is selected
            if (customer.smsNotification) {
                if (!customer.user_mobile_number) {
                    customer.smsNotificationError = 'Phone number is required when notify by SMS is selected.';
                    hasError = true;
                } else if (!formatPhone(customer.user_mobile_number)) {
                    customer.smsNotificationError = 'Invalid phone number format.';
                    hasError = true;
                }
            }

            if (hasError) return;

            // Deep copy to avoid mutation issues
            const updatedCustomer = JSON.parse(JSON.stringify(customer));

            // Update in selectedMemberss
            const index = state.data.selectedMembers.findIndex(
                (m: any) => m.user_id === updatedCustomer.user_id
            );

            if (index !== -1) {
                // Reactive replacement using splice
                state.data.selectedMembers.splice(index, 1, updatedCustomer);
            } else {
                // Add if not found
                state.data.selectedMembers.push(updatedCustomer);
            }

            closeEditCustomerModal();
        }

        function selectCustomerChannelAll(channelId = '', searchQuery = '', page = 1, isLoadMore = false) {
            state.ui.isLoading.customerChannelMemberList = true;
            state.data.selectedChannelUuid = channelId;

            ethitransService.customerChannelMemberListAll(searchQuery, 10, page)
                .then((res: any) => {
                    const response = res.data.data || {};
                    const members = response.data || [];
                    const taggedMembers = members.map((member: any) => ({
                        ...member,
                        emailFromApi: !!member.user_email && isEmail(member.user_email),
                        phoneFromApi: !!(member.user_mobile_number || member.user_phone),
                    }));

                    if (isLoadMore) {
                        // Prepend new members at the top
                        state.data.apiChannelMembers = [...taggedMembers, ...state.data.apiChannelMembers];
                    } else {
                        state.data.apiChannelMembers = taggedMembers;
                    }

                    // Save pagination info
                    state.ui.channelMemberPage = response.current_page;
                    state.ui.channelMemberLastPage = response.last_page;
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.customerChannelMemberList = false;
                });
        }

        function switchTab(tab: string) {
            if (state.activeTab === tab) return;
            clearAllSearchInputs()
            state.ui.searchQuery.customerChannel = '';
            state.ui.searchQuery.channelMembers = '';
            state.ui.searchQuery.projects = '';

            if (tab === 'projectstb') {
                state.data.selectedFilterProjectTab = 'channel';
                customerChannelList();
            }

            if (tab === 'mycustomerstb') {
                state.data.selectedFilterCustomerTab = 'channel';
                customerProjectList();
            }

            state.activeTab = tab;
        }

        watch(
            () => state.data.customerToEdit?.user_email,
            (newVal) => {
                if (!state.ui.showEditCustomerModal || !state.data.customerToEdit) return;

                state.data.customerToEdit.mailNotification = validationService.isValidEmail(newVal);
            }
        );

        watch(
            () => state.data.customerToEdit?.user_mobile_number,
            (newVal) => {
                if (!state.ui.showEditCustomerModal || !state.data.customerToEdit) return;
                const cleanedNumber = newVal?.replace(/[\s()-]/g, '');
                state.data.customerToEdit.smsNotification = validationService.validateMobileNumber(cleanedNumber);
            }
        );
        function onDynamicMemberScroll(event: any) {
            const el = event.target;

            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                if (state.ui.isLoading.customerChannelMemberList) return;

                const nextPage = state.ui.channelMemberPage + 1;

                if (
                    state.data.selectedFilterCustomerTab === 'channel' &&
                    state.ui.channelMemberPage < state.ui.channelMemberLastPage
                ) {
                    selectCustomerChannel(
                        state.data.selectedChannelUuid,
                        state.ui.searchQuery.channelMembers,
                        nextPage,
                        true
                    );
                }

                if (
                    state.data.selectedFilterCustomerTab === 'member' &&
                    state.ui.channelMemberPage < state.ui.channelMemberLastPage
                ) {
                    projectMembersListAll(
                        state.ui.searchQuery.channelMembers,
                        nextPage,
                        true
                    );
                }
            }
        }


        function startRecording(newValue: any) {
            // console.log('The New Value is>>', newValue)
            // state.data.note = state.data.note ? state.data.note : '' + ' ' + newValue;
            state.data.note = (state.data.note ? state.data.note + ' ' : '') + newValue;
            // console.log('The updated note data is>>', state.data.note)
        }



        onMounted(() => {
            getJobEstimationDetails(props.editId);
            userStatus();
            getItemList();
            userSignature('onMount');
            if (projectId) {
                customerChannelList();
            }
        });


        const editRow = (index: number) => {
            const user = state.selectItems[index];    
            user.isEditing = true;
        };

        const saveRow = (index: number) => {
            const user = state.selectItems[index]; 
            if (user) {
                user.isEditing = false;
            }
        }

        return {
            state,
            getItemList,
            checkSubItem,
            startRecording,
            checkItem,
            closeSelected,
            removeSelectedSubItem,
            addMoreSubItems,
            checkInputNumber,
            calculateTotal,
            addUnitShow,
            addUniteClose,
            changeMarkupType,
            changeUnit,
            addNewUnit,
            editUnit,
            deleteUnitList,
            deleteUnit,
            createUnit,
            updateUnit,
            total,
            totalMarkUP,
            clearAllJobItem,
            creatJobEstimation,
            gotoJobEstimation,
            closeSuccessCustomModal,
            addNewSubItem,
            saveItem,
            validationCreateJobEstimation,
            getJobestimationDetail,
            updateJobEstimation,
            saveSend,
            gotoJobEstimationSend,
            deleteItemClose,
            deleteItemShow,
            updateItem,
            updateItemMarkup,
            updateItemAllowance,
            usdPriceFormate,
            cloneItem,
            formatPrice,
            formatCurrency,
            getJobEstimationDetails,
            convertValues,
            addCustomerEmail,
            changeValue,
            isInvalid,
            readLogo,
            uploadLogo,
            readImage,
            dropFiles,
            readSignature,
            onDocumentChange,
            showUploadImageModel,
            hideShowUploadImageModel,
            enableSignaturPad,
            hideCreateCompanyModel,
            showCreateCompanyModel,
            createCompanyIfno,
            validateCreateCompany,
            editCompany,
            userStatus,
            tabulator,
            table,
            resizeTable,
            applyFilter,
            filterValue,
            onToggleChooseItem,
            iconFormatter,
            addSubItem,
            validateSendInvitation,
            sendJobEstimation,
            showSignaturePad,
            hideSignaturePad,
            uploadSignature,
            uploadSignatureFile,
            hideSignatureUpload,
            userSignature,
            clearSignature,
            showDelete,
            hideDelete,
            isEmailValid,
            isPhoneValid,
            removeSelectCustomer,
            editSelectCustomer,
            updateSelectCustomer,
            fetchCustomerDetails,
            address,
            latitude,
            longitude,
            showMap,
            updateLatitude,
            updateLongitude,
            updateAddress,
            customer,
            redirectToChat,
            hideChatChannel,
            handleChannelSelection,
            handleCheckboxChange,
            signatureInput,
            handleProjectChannelScroll,
            handleInput,
            handleProjectScroll,
            handleChannelMemberScroll,
            handleChannelScroll,
            onProjectSearchInput,
            onChannelMemberSearchInput,
            onChannelSearchInput,
            toggleMemberSelection,
            addCustomer,
            formatMobileNumber,
            resetForm,
            allCustomerChannelList,
            handleFilterChangeAll,
            handleFilterChange,
            enteredValue,
            clearInputValue,
            selectedMembers,
            customerProjectList,
            customerChannelList,
            selectCustomerChannel,
            projectChannelList,
            projectMembersList,
            channelMembers,
            removeSelectedMember,
            closeEditCustomerModal,
            selectCustomerChannelAll,
            switchTab,
            isEmail,
            projectMembersListAll,
            onDynamicMemberScroll,
            resetMemberPagination,
            debouncedCustomerChannel,
            debouncedChannelMembers,
            debouncedProjects,
            debouncedProjectChannel,
            debouncedMemberSearch,
            clearAllSearchInputs,
            cleanPhone,
            showLineItemModal,
            itemSearchedvalue,
            currenylySelectedState,
            editRow,
            saveRow
        };
    },
});
